import Grid from '@mui/material/Grid';
import { Fragment } from 'react';

import Icon, { IconName } from '@/components/Icon/Icon';
import GridContainer from '@/components/Layout/GridContainer/GridContainer';
import Link from '@/components/Link/Link';
import {
  type Contentful,
  ContentStyle,
  type FooterMenuContent,
} from '@/contentful/contentful-exports';

import useStyles from './GlobalMinimalFooter.styles';
export interface GlobalMinimalFooterContent extends Contentful {
  fields: {
    copyrightText: string;
    legalLinks: FooterMenuContent;
    variant: 'light' | 'dark';
    style: ContentStyle;
  };
}
export interface GlobalMinimalFooterProps {
  content: GlobalMinimalFooterContent;
}

const GlobalMinimalFooter: React.FC<GlobalMinimalFooterProps> = ({
  content: {
    fields: { copyrightText, legalLinks, style },
  },
}: GlobalMinimalFooterProps) => {
  const isOnDark = style === ContentStyle.OnDark;
  const { classes } = useStyles({ isOnDark });
  return (
    <footer className={classes.container}>
      <GridContainer
        fixed
        wrapperProps={{ className: classes.gridWrapper }}
        gridProps={{ className: classes.grid }}
      >
        <Grid size={12} className={classes.content}>
          <div className={classes.copyright}>{copyrightText}</div>
          <div className={classes.legalLinks}>
            {legalLinks.fields.links?.map(
              ({ fields: { text, url } }, index, array) => (
                <Fragment key={text}>
                  <Link
                    className={`${classes.legalLink} ${
                      text === 'Your Privacy Choices'
                        ? classes.legalLinkPrivacy
                        : ''
                    }`}
                    href={url}
                  >
                    {text}
                  </Link>
                  {text === 'Your Privacy Choices' && (
                    <div
                      className={classes.privacyOptions}
                      data-testid='privacy-options'
                    >
                      <Icon name={IconName.PRIVACY_OPTIONS} width={30} />
                    </div>
                  )}
                  {index < array.length - 1 && (
                    <span className={classes.legalLinkSlash}>/</span>
                  )}
                </Fragment>
              )
            )}
            {(legalLinks.fields.links?.length ?? 0) > 0 && (
              <span className={classes.legalLinkSlash}>/</span>
            )}
            <Link href='/llms.txt' className={classes.legalLink}>
              LLMs.txt
            </Link>
            <span className={classes.legalLinkSlash}>/</span>
            <Link href='/ai.txt' className={classes.legalLink}>
              AI.txt
            </Link>
          </div>
        </Grid>
      </GridContainer>
    </footer>
  );
};

export default GlobalMinimalFooter;
